module.exports = __webpack_public_path__ + "static/media/iarnrod.e9983008.png";